import localStorageSupport from 'helpers/localStorageSupport';

const defaults = {
  cookieIDAttr: 'data-notice-cookie-id',
  closeButtonSelector: '[data-notice-hide]'
};

class Notice {

  constructor (element, settings) {
    this.notice = element;
    this.options = Object.assign({}, defaults, settings);
    this.noticeClose = element.querySelector(this.options.closeButtonSelector);
    this.cookieID = element.getAttribute(this.options.cookieIDAttr);
    this.clickListener = this.clickEvent.bind(this);
  }

  addEventListeners () {
    if (this.noticeClose) {
      this.noticeClose.addEventListener('click', this.clickListener, false);
    }
  }

  removeEventListeners () {
    if (this.noticeClose) {
      this.noticeClose.removeEventListener('click', this.clickListener, false);
    }
  }

  removeNotice () {
    this.notice.parentNode.removeChild(this.notice);
  }

  showNotice () {
    this.notice.classList.remove('is-hidden');
    this.notice.setAttribute('aria-hidden', false);
  }

  hideNotice () {
    this.notice.classList.add('is-hidden');
    this.notice.setAttribute('aria-hidden', true);
  }

  initNotice () {
    this.notice.classList.add('is-initialized');
  }

  clickEvent (e) {
    e.preventDefault();
    this.hideNotice();
    if (this.cookieID) {
      this.setCookieValue(this.cookieID);
    }
    setTimeout(() => this.removeNotice(), 1000);
  }

  removeAllAttrs () {
    this.noticeClose.removeAttribute('aria-hidden');
  }

  removeAllClasses () {
    this.notice.classList.remove('is-hidden');
    this.notice.classList.remove('is-initialized');
  }

  setCookieValue (id) {
    if (localStorageSupport && window.JSON !== 'undefined') {
      return window.localStorage.setItem(id, JSON.stringify({ suppressed: true }));
    }
  }

  getCookieValue (id) {
    if (localStorageSupport && window.JSON !== 'undefined') {
      return window.localStorage.getItem(id);
    }
  }

  testForHideOnLoad () {
    if (this.getCookieValue(this.cookieID)) {
      this.removeNotice();
    } else {
      this.initNotice();
    }
  }

  init () {
    this.addEventListeners();
    if (this.cookieID) {
      this.testForHideOnLoad();
    } else {
      this.initNotice();
    }
  }

  destroy () {
    this.removeAllAttrs();
    this.removeAllClasses();
    this.removeEventListeners();
  }
}

export default Notice;
